import router from "@/router/router";
import { useStore } from "vuex";

let permission = {
    isInsert: false,
    isModify: false,
    // isDelete: false,
    isComment: false,
    isDownload: false,
    isSpecial: false,
    isUse: false
}

/**
 * 메뉴별 권한
 * isInsert: 추가 / isModify: 수정 / isDelete: 삭제 (주석) / isComment: 댓글 / isDownload: 다운로드 / isSpecial: 특정 기능
 * 
 * [2025.01.23. leejingyeong] update(수정/삭제) 기능으로 편집으로 사용 delete(삭제) 권한은 사용하지 않음. 추후에 삭제를 별도로 관리할 시 주석 해제하고 관리할 것
 * 
 * @returns 
 */
export const useCheckPermission = (routerMenu) => {

    const keys = [
        'isUse', 
        'isInsert', 
        'isModify', 
        // 'isDelete', 
        'isComment', 
        'isDownload', 
        'isSpecial'
    ] // v-if 변수명

    const store = useStore(); 

    const menuList = store.state.login.menuList
    let currentMenu = router.currentRoute.value.meta.menuPath || router.currentRoute.value.path

    if(routerMenu){
        currentMenu = routerMenu
    }
    const filteredMenu = menuList.find(item => item.siteUrl === currentMenu)
    // if(filteredMenu.length > 0 && filteredMenu[0].parentMenuCode){
    //     const parentMenu = menuList.filter(item => item.menuCode === filteredMenu[0].parentMenuCode);
        
    //     if(parentMenu.length > 0 && parentMenu[0].parentMenuCode){
    //         const grantParentMenu = menuList.filter(item => item.menuCode === parentMenu[0].parentMenuCode);                    
    //         permission = handleAssignMenuPermission(grantParentMenu[0], parentMenu[0], filteredMenu[0], keys)
    //     }
    // }else{
    if(filteredMenu){
        permission = {
            isInsert: filteredMenu?.isInsert || false,
            isModify: filteredMenu?.isModify || false,
            // isDelete: filteredMenu?.isDelete || false,
            isComment: filteredMenu?.isComment || false,
            isDownload: filteredMenu?.isDownload || false,
            isSpecial: filteredMenu?.isSpecial || false,
            isUse: filteredMenu?.isUse || false,
        }    
    }
    // }
    return permission;
}

/**
 * 메뉴별 허용 권한 분배 작업
 * 상위에 해당하는 메뉴의 비허용(false)이 우선순위가 된다.
 * @param {*} grantParentMenu 최상위 (1순위)
 * @param {*} parentMenu 중위 (2순위)
 * @param {*} filteredMenu 하위 (3순위)
 * @param {*} keys 
 * @returns 
 */
const handleAssignMenuPermission = (grantParentMenu, parentMenu, filteredMenu, keys) => {
    keys.forEach(key => {
        permission[key] = false;
        if(!grantParentMenu[key]){ 
            
            permission[key] = false
        }else{
            
            if(!parentMenu[key]){
                permission[key] = false
            }else{
                permission[key] = filteredMenu[key]
            }
        }    
    })
    return permission
}